import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Backdrop } from '@mui/material';

interface LoadingCircularProps {
    open: boolean | false;
}
export default function BackdropCircularIndeterminate(props: LoadingCircularProps) {
    const { open } = props;

    return (
        <Backdrop
            sx={{ opacity: 0.1, backgroundColor: 'none', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}
